var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.25 41.69",
    id: "gallery",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M25 34.88a6.08 6.08 0 0 1-3.83-1.43l-7.07-6.23a3.12 3.12 0 0 0-4-.19L0 34.42v4.81a2.34 2.34 0 0 0 2.2 2.46h35.85a2.73 2.73 0 0 0 2.85-2.47V26.63L28.12 34a5.91 5.91 0 0 1-3.12.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.48,
    cy: 19.43,
    r: 2.86,
    fill: "#CE28B7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M47.65 5.09a2.36 2.36 0 0 0-1.75-1L10.53 0a2.6 2.6 0 0 0-2.92 2.23L7 7.29h31a5.59 5.59 0 0 1 5.45 5.39v22.91c0-.13.59-.26.85-.52a2.23 2.23 0 0 0 .84-1.76L48.24 7a2.54 2.54 0 0 0-.59-1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m15.78 25.27 7.14 6.23a3.3 3.3 0 0 0 3.83.33l14.15-8.24V12.68A3 3 0 0 0 38 9.89H2.41A2.58 2.58 0 0 0 0 12.66v18.52L8.58 25a5.71 5.71 0 0 1 7.2.27ZM24.48 14A5.45 5.45 0 1 1 19 19.43 5.45 5.45 0 0 1 24.48 14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoGallery);
export default __webpack_public_path__ + "static/media/go-gallery.dd06780f5ff5c4aaf34cc2aa6218d6ad.svg";
export { ForwardRef as ReactComponent };